<template>
  <div class="">
    <div class="index1_until">
      <div class="index1_until_shu"></div>
      <div class="index1_until_text">其他预警</div>
    </div>
    <div class="box3">
      <div class="" style="width: 430px;">
        <div class="box3_right cpoint">
          <div class="box3_center">
            <input @keyup.enter.prevent="searchEnterFun($event)" v-model="keyword" placeholder="请输入搜索内容"/>
            <div @click="tosearch" class="box3_sou">
              <div class="box3_tu">
                <img style="width: 25px;height: 25px;" src="/static/assets/images/sou.png" />
              </div>
              <div style="font-size: 16px;">搜索</div>
            </div>
          </div>
        </div>
        <div class="flex justify-between align-center" style="border: solid 2px #eeeeee;">
          <div v-for="(item,index) in tablist" @click="tochoose(index,item.status)" :key="index" class="box3_text pointer" :class="tindex == index ? 'cc' : ''">{{item.title}}</div>
        </div>
      </div>
      <div class="">
        <div class="rightnum text-right text-white">
          <div class="" style="font-size: 42px;font-weight: 600;margin-bottom: 10px;">￥{{total_money ? total_money : '0.00'}}</div>
          <div class="" style="font-size: 15px;">共查找到 {{totalnum ? totalnum : '0'}} 条记录，预警费用总计{{total_money ? total_money : '0.00'}}元</div>
        </div>
      </div>
    </div>
    <div class="box55">
      <div class="box2">
        <div class="box2_center">
          <table class="bo" cellpadding="0" cellspacing="0">
            <tr class="bo_cc">
              <td>企业名称</td>
              <td>企业联系人</td>
              <td>联系人电话</td>
              <td>缴费项目</td>
              <td>支付方式</td>
              <td>价格</td>
              <td>费用到期时间</td>
              <td>到期应收</td>
              <td>操作</td>
            </tr>
            <tr v-for="(item,index) in tenlist" :key="index">
              <td>{{item.shop.shop_name ? item.shop.shop_name : '--'}}</td>
              <td>{{item.shop.people_name ? item.shop.people_name : '--'}}</td>
              <td>{{item.shop.mobile ? item.shop.mobile : '--'}}</td>
              <td>{{item.title ? item.title : '--'}}</td>
              <td>{{item.pay_way ? item.pay_way : '--'}}</td>
              <td>{{item.price ? item.price :'--'}}</td>
              <td>{{item.expire_time ? item.expire_time :'--'}}</td>
              <td>{{item.real_money ? item.real_money :'--'}}</td>
              <td class="box2_tt pointer" @click="showdetail(item)">
                  详情
              </td>
            </tr>
          </table>
          <div v-if="!tenlist.length && !getstatus">
            <nomore></nomore>
          </div>
        </div>
      </div>
      <div class="text-center" style="padding: 10px 0;">
          <el-pagination
          background
          :page-size="pagesize"
          :hide-on-single-page="true"
          layout="prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :total="totalnum">
          </el-pagination>
        </div>
    </div>
    <el-dialog title="预警详情" :visible.sync="addcompany" >
      <div class="" v-if="cominfo" style="text-align: center;width: 60%;margin: 0 auto;">
        <el-form :model="cominfo" style="text-align:center;">
          <el-form-item label="企业名称" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.shop.shop_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="企业联系人" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.shop.people_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.shop.mobile" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="地址" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.shop.add_detail" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="所属分类" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.shop.cat_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="入驻时间" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.shop.createtime" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="缴费项目" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.title" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="支付方式" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.pay_way" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="价格" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.price" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="费用到期时间" :label-width="formLabelWidth">
            <!-- <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.expire_time" autocomplete="off"></el-input> -->
            <el-date-picker
                  v-model="cominfo.expire_time"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  style="width: 420px;"
            >
                </el-date-picker>
          </el-form-item>
          <el-form-item label="到期应收" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.real_money" autocomplete="off"></el-input>
          </el-form-item>

        </el-form>
      </div>
      
      <div slot="footer" class="flex justify-between align-center">
        <div class="" style="color: #11afc7;font-size: 18px;">到期应收：￥<span style="font-size: 25px;">{{cominfo.real_money}}</span></div>
        <el-button @click="subbtn" type="primary">已缴费，解除预警</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return{
      tenlist: [],
      tablist:[{
        title: '全部',
        status: 0
      },{
        title: '近一周内到期',
        status: 2
      },{
        title: '近一月内到期',
        status: 1
      }],
      getstatus: false,
      status: 0,
      tindex: 0,
      pagesize: 7,
			currentPage: 1,
			totalnum: null,
      keyword: '',
      newroom:'',
			formLabelWidth: '120px',
      form:{
        hourse_number: '',
        hourse_floor: '',
        fang_number: '',
        area: '',
        work_number: '',
        user_id: '',
        id: ''
      },
      cominfo:'',
      addcompany: false,
      editmodel: false,
      systeminfo:'',
      total_money: 0
    }
  },
  computed: {
		...mapGetters(["token"])
  },
  methods:{
    subbtn(){
      var data = {
        type: 2,
        id: this.cominfo.id,
        expire_time: this.cominfo.expire_time
      }
      this.$api.system.update_time(data).then(res => {
        this.$message.success(res.msg);
        this.addcompany = false;
        this.getnewlist();
      })
    },
    showdetail(item){
      this.cominfo = item;
      this.addcompany = true;
    },
    handleSizeChange(){

    },
    handleCurrentChange(currentPage){
      this.currentPage = currentPage;
      this.getlist();
    },
    todelete(){

    },
    emptyedit(){},
    searchEnterFun(){

    },
    searchEnterFun(e){
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
          this.tosearch();
      }
		},
      tosearch(){
        this.list = [];
        this.currentPage = 1;
        this.totalnum = 0;
        this.getlist();
      },
      tochoose(index,status){
        this.status = status;
        this.tindex = index;
        this.getnewlist();
    },
    getnewlist(){
      this.getstatus = false;
      this.tenlist = [];
      this.currentPage = 1;
      this.totalnum = 0;
      this.getlist();
    },
    emptyedit(){
      this.addcompany = true;
    },
    getlist(){
      var data = {
        admin_id: this.token,
        keyword: this.keyword,
        start: this.currentPage,
        page_size: this.pagesize,
        type: this.tindex
      }
      this.$api.system.ortherwarn_list(data).then(res => {
        this.tenlist = res.data.list;
        this.totalnum = res.count;
        this.total_money = res.data.total_money;
        if(res.data.list.length){
          this.getstatus = true;
        }else{
          this.getstatus = false;
        }
      }).catch(res=>{
        this.getstatus = false;
      })
    },
  },
  created(){
      this.getlist();
  }
}
</script>
<style>
  .el-dialog__header{
    background-color: #2c3e50;
  }
  .el-dialog__title{
    color: #fff !important;
  }
  .el-dialog__footer{
    background-color: #ecf0f1;
    padding: 20px 50px !important;
  }
</style>
<style scoped>
.box1_right_center{
	height: 120px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
}
.box1_right_cent{
	width: 20%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	position: relative;
}
.box1_shu{
	position: absolute;
	width: 1px;
	height: 47px;
	background-color: #e5e5e5;
	left: 0;
}
.box1_right_cent:first-child .box1_shu{
	display: none;
}
.box1_text{
	font-size: 50px;
	color: #131313;
}
.box1_text1{
	font-size: 18px;
	color: #8a8a8a;
	width: 80%;
	text-align: center;
}
.box3 {
  display: flex;
  width: 95%;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}
.box3_center {
  width: 100%;
  height: 48px;
  background-color: #ffffff;
  box-shadow: 0px 2px 18px 0px rgba(141, 142, 144, 0.24);
  border-radius: 8px;
  border: solid 1px #eeeeee;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.box3_lie {
  width: 123px;
  height: 42px;
  background-color: #ffffff;
  border-radius: 21px;
  border: solid 1px #6491ff;
  font-size: 18px;
  color: #6491ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
}
.box3_lie1 {
  width: 123px;
  height: 42px;
  background-color: #6491ff;
  border-radius: 21px;
  border: solid 1px #6491ff;
  font-size: 18px;
  color: #ffffff;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  bottom: 70px;
}
.box3_right {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 30px;
}
input {
  width: 90%;
  background: none;
  outline: none;
  border: none;
  margin-left: 20px;
}
.box3_tu {
  width: 25px;
  height: 25px;
  margin-right: 8px;
}
.box3_sou {
  display: flex;
  width: 90px;
  align-items: center;
  height: 100%;
  font-size: 18px;
  color: #6491ff;
}
.box3_text {
  font-size: 18px;
  color: #a3a3a3;
  height: 35px;
  display: flex;
  padding: 0 7px;
  align-items: center;
  border-right: 1px solid #eee;
  justify-content: center;
  width: 33%
  /* border-bottom: 4px solid #ffffff; */
}
.cc {
  /* border-bottom: 4px solid #3973ff; */
  color: #fff;
  background: #3d7fff;
}
.box5_cent {
  padding: 0 7px;
  height: 56px;
  line-height: 56px;
  background-color: #6491ff;
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  border-right: 1px solid #ffffff;
}
.box5 {
  width: 95%;
  display: flex;
  justify-content: center;
  padding-top: 20px;
  margin: 0 auto;
}
.box5_center {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.box5_ce {
  width: 100%;
  height: 80px;
  font-size: 12px;
  text-align: center;
  border-right: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
}
.box5_center:first-child .box5_ce {
  border-left: 1px solid #eeeeee;
}
.a1 {
  width: 69px;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  line-height: 20px;
}
.a2 {
  width: 69px;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  line-height: 20px;
  word-break: break-all;
  flex-direction: column;
  justify-content: center;
}
.a3_tu {
  width: 23px;
  height: 23px;
  margin-right: 22px;
}
.a3_tu:last-child {
  margin-right: 0;
}
.a3 {
  display: flex;
  margin: 0 8px;
}
.a3_text {
  width: 50px;
  height: 23px;
  background-color: #6491ff;
  border-radius: 12px;
  font-size: 12px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}


td {
  line-height: 85px;
  text-align: center;
  padding: 0 9px;
  height: 85px;
  border-top: 1px solid #efefef;
  border-left: 1px solid #efefef;
}
td:last-child {
  border-right: 1px solid #efefef;
}
.bo_cc td {
  height: 56px;
  line-height: 56px;
}
.box2_tu {
  width: 15px;
  height: 15px;
  margin-left: 3px;
}
.box2_tt {
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 0;
  color: #6491ff;
}
.bo {
  margin-top: 24px;
  margin-bottom: 70px;
  border-bottom: 1px solid #efefef;
  font-size: 12px;width: 100%;
}
.bo_cc {
  background-color: #6491ff;
  font-size: 14px;
  color: #ffffff;
}
.box2_tt {
  line-height: 14px;
}
.box2_aa_tu {
  width: 20px;
  height: 20px;
  line-height: 0;
  margin-left: 5px;
}
.box2_aa {
  display: flex;
  align-items: center;
}
.box2 {
  width: 95%;
  margin: 0 auto;
}
@media screen and (max-width: 1600px) {
  .box1_right {
    width: 90%;
  }
  td {
    padding: 0 3px;
  }
}
.rightnum{
  width: 380px;
	height: 105px;
	background-color: #3d7fff;
	border-radius: 4px;
  padding: 20px 20px 0 20px;
}
</style>



// WEBPACK FOOTER //
// otherwarning.vue?cbea7c1e